/**
 * Chart.js 전역 설정
 *
 * lazy loading 환경에서 Chart.js 요소들이 분리된 청크에서 사용되기 전에
 * 모든 필요한 요소들을 미리 등록합니다.
 *
 * 이 파일은 index.js에서 App보다 먼저 import되어야 합니다.
 */
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

// 모든 Chart.js 요소 전역 등록
ChartJS.register(
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement, // Pie/Doughnut 차트용
  Title,
  Tooltip,
  Legend,
  Filler,
);

export default ChartJS;
